export default function EduzzToolbarSetup(params) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://unpkg.com/@eduzz/apps-toolbar@^2.0.10/dist/widget.js';

    script.onload = () => {
      const toolbar = window.EduzzAppsToolbar(params);
      resolve(toolbar);
    };

    script.onerror = err => {
      import('@eduzz/apps-toolbar/dist/widget.js')
        .then(() => {
          console.log('@eduzz/apps-toolbar: LOADING FROM FALLBACK');
          const toolbar = window.EduzzAppsToolbar(params);
          resolve(toolbar);
        })
        .catch(() => reject(err));
    };

    document.body.append(script);
  });
}
